/**
 * bootstrap defaults
 * {@link https://getbootstrap.com/docs/4.6/extend/approach/#component-elements}
 * {@link https://getbootstrap.com/docs/4.6/layout/overview/#z-index}
 */

export const COMPONENT_DEFAULT = 0;
export const COMPONENT_HOVER = 1;
export const COMPONENT_ACTIVE = 2;
export const COMPONENT_FOCUS = 3;
export const DROPDOWN_DEFAULT = 1000;
export const STICKY_DEFAULT = 1020;
export const FIXED_DEFAULT = 1030;
export const MODAL_BACKDROP_DEFAULT = 1040;
export const MODAL_DEFAULT = 1050;
export const POPOVER_DEFAULT = 1060;
export const TOOLTIP_DEFAULT = 1070;

export const COMPONENT_OVERRIDE = COMPONENT_DEFAULT + 1;
export const DROPDOWN_OVERRIDE = DROPDOWN_DEFAULT + 1;
export const STICKY_OVERRIDE = STICKY_DEFAULT + 1;
export const FIXED_OVERRIDE = FIXED_DEFAULT + 1;
export const MODAL_BACKDROP_OVERRIDE = MODAL_BACKDROP_DEFAULT + 1;
export const MODAL_OVERRIDE = MODAL_DEFAULT + 1;
export const POPOVER_OVERRIDE = POPOVER_DEFAULT + 1;
export const TOOLTIP_OVERRIDE = TOOLTIP_DEFAULT + 1;
